document.addEventListener('DOMContentLoaded', async () => {
  let userGeolocation = localStorage.getItem('userGeolocation');

  async function getUserGeo() {
    if (userGeolocation) {
      return userGeolocation;
    }

    try {
      const response = await fetch("https://ipapi.co/json/");
      const json = await response.json();
      console.log(json)
      userGeolocation = json.country_code;
      userGeolocationName = json.country_name;
      userGeolocationPostal = json.postal;
      localStorage.setItem('userGeolocationName', userGeolocationName);
      localStorage.setItem('userGeolocation', userGeolocation);
      localStorage.setItem('userPostCode', userGeolocationPostal);      
      return userGeolocation;
    } catch (error) {
      console.error("❌ Ошибка получения геолокации:", error);
      return null;
    }
  }
getUserGeo();

});


document.addEventListener("DOMContentLoaded", function () {
  const userGeolocation = localStorage.getItem('userGeolocation'); // e.g., "US"

  const cardUSAOnly = document.querySelector('product-card[id="8851006652653"]');
  const cardNonUSAOnly = document.querySelector('product-card[id="8992784974061"]');

  if (cardUSAOnly) {
    const parentLi = cardUSAOnly.closest('li');
    if (parentLi) {
      if (userGeolocation !== 'US') {
        parentLi.style.display = 'none';
      } else {
        parentLi.style.display = '';
      }
    }
  }
  if (cardNonUSAOnly) {
    const parentLi = cardNonUSAOnly.closest('li');
    if (parentLi) {
      if (userGeolocation === 'US') {
        parentLi.style.display = 'none';
      } else {
        parentLi.style.display = '';
      }
    }
  }
});


// Функция для установки обработчиков событий на кнопки с классом .xsell-quick-add-to-cart
function setUpQuickAddToCartListeners() {
  const buttons = document.querySelectorAll('.xsell-quick-add-to-cart');

  if (buttons.length > 0) {
    buttons.forEach(button => {
      button.addEventListener('click', function() {
        setTimeout(() => {
          const menuLists = document.querySelectorAll('.xsell-quick-add-to-cart-menu-list');
          if (menuLists.length > 0) {
            setUpMenuListListeners(menuLists);
          } else {
            const modalCloseButton = document.querySelector('.xsell__modal-close');
            if (modalCloseButton) {
              modalCloseButton.click();
            }
          }
        }, 4000);
      });
    });
  } else {
    // Если кнопки не найдены, повторяем проверку через 500 миллисекунд
    setTimeout(setUpQuickAddToCartListeners, 500);
  }
}

// Функция для установки обработчиков событий на элементы li внутри .xsell-quick-add-to-cart-menu-list
function setUpMenuListListeners(menuLists) {
  menuLists.forEach(menu => {
    const items = menu.querySelectorAll('li');
    items.forEach(item => {
      item.addEventListener('click', function() {
        // Обработка клика по li
        // Имитация клика по кнопке .xsell__modal-close
        const modalCloseButton = document.querySelector('.xsell__modal-close');
        if (modalCloseButton) {
          setTimeout(() => {
            modalCloseButton.click();
          },4000)
        }
      });
    });
  });
}
setUpQuickAddToCartListeners();
